import React, { useState, useRef, useEffect } from 'react'
import classnames from 'classnames'
import { message } from 'antd'
import Sortable from '@shopify/draggable/lib/es5/sortable'
import cloneDeep from 'lodash/cloneDeep'
import Upload from 'meinian-package/src/component/upload/image'
import Button from 'meinian-package/src/baseComponent/button'
import { request } from 'meinian-package/src/utils'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import { FirstNormalTip } from 'meinian-package/src/component/firstTooltip'
import { isPermissions } from 'meinian-package/src/utils/auth'
import Icon from 'meinian-package/src/component/icon'
import { useDeepCompareEffect } from 'ahooks'
import { ossImg } from 'meinian-package/src/utils/image'
import ImageGalleryModal from '../imageGalleryModal'
import styles from './index.module.less'

export default ({ imgInfoList, setImgInfoList, init, hiddenDeleteBtn = false, collectId, currentImage, setInnerIndex }) => {
  const [imageId, setImageId] = useState(currentImage?.imageId)
  useEffect(() => {
    if (currentImage?.imageId !== imageId) {
      setImageId(currentImage.imageId)
    }
  }, [currentImage])

  const onDelete = async (e, curData) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '确认删除',
      content: '是否确认删除该图片？',
      onOk: async () => {
        const currentIndex = imgInfoList.findIndex((item) => item.imageId === curData.imageId)
        if (currentIndex !== -1) {
          imgInfoList.splice(currentIndex, 1)
          await modifyFetch(imgInfoList)
          message.success('删除图片成功')
          if (imageId === curData.imageId) {
            setImageId(imgInfoList?.[0]?.imageId)
          }
          init()
        }
      },
    })
  }

  const onGallery = async (images) => {
    await modifyFetch(images)
    init()
  }
  const modifyFetch = async (images) => {
    const result = await request.post('/zhikuan/inspiration/blog/update-blog-image ', {
      collectId,
      blogGalleryList: images.map((m) => ({
        childEntityId: m.childEntityId,
        childEntityIndex: m.imageGroupIndex,
        childMainUrl: m.mainUrl,
        childPlatformId: m.childPlatformId,
      })),
    })
    return result
  }

  const onSort = async (list) => {
    setImgInfoList(list)
    await modifyFetch(list)
  }

  const { loginUserInfo } = imgInfoList?.[0] || {}
  const auth = loginUserInfo?.inspirationPermissions || []
  const hasAuth = isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])
  return (
    <div className={styles['meinian-image-box-pagination']}>
      <div className="thumbs" style={{ paddingTop: `${hasAuth ? '32px' : '8px'}` }}>
        {isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) && (
          <ImageGalleryModal images={imgInfoList} onChange={onGallery}>
            <Button type="normal" className="meinian-image-box-paginatio-new-create">
              新增图片
            </Button>
          </ImageGalleryModal>
        )}
        <BaseSortThumbs
          imgInfoList={imgInfoList}
          setInnerIndex={setInnerIndex}
          setImageId={setImageId}
          imageId={imageId}
          onDelete={onDelete}
          onSort={onSort}
          hiddenDeleteBtn={hiddenDeleteBtn}
          auth={isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])}
        />
      </div>
    </div>
  )
}

export const SampleImageBoxPagination = ({
  currentImage,
  imgInfoList,
  init,
  setImgInfoList,
  setInnerIndex,
  hiddenDeleteBtn = false,
}) => {
  const [imageId, setImageId] = useState(currentImage?.imageId)
  useEffect(() => {
    if (currentImage?.imageId !== imageId) {
      setImageId(currentImage.imageId)
    }
  }, [currentImage])

  const onDelete = async (e, curData) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '确认删除',
      content: '是否确认删除该图片？',
      onOk: async () => {
        const currentIndex = imgInfoList.findIndex((item) => item.imageId === curData.imageId)
        if (currentIndex !== -1) {
          imgInfoList.splice(currentIndex, 1)
          await modifyFetch(imgInfoList)
          message.success('删除图片成功')
          if (imageId === curData.imageId) {
            setInnerIndex(0)
            setImageId(imgInfoList?.[0]?.imageId)
          }
          init()
        }
      },
    })
  }
  const afterUpload = async (files) => {
    const file = files[0]
    imgInfoList.push({ mainUrl: file?.url, height: file?.height, width: file?.width, annotationNum: 0 })
    await modifyFetch(imgInfoList)
    init()
  }

  const modifyFetch = async (images) => {
    const result = await request.post('/zhikuan/mn/sample/update-sample-image', {
      id: currentImage.id,
      imgUrlList: images.map((m) => ({
        height: m.height,
        width: m.width,
        mainUrl: m.mainUrl,
        id: m.id,
        annotationNum: m.annotationNum,
      })),
    })
    return result
  }

  const onSort = async (list) => {
    setImgInfoList(list)
    await modifyFetch(list)
  }

  return (
    <div className={styles['meinian-image-box-pagination']}>
      <div className="thumbs" style={{ paddingTop: '8px' }}>
        {isPermissions(currentImage.sampleClothingAuth, ['operateAndUpdateSample']) && (
          <Upload onSuccess={afterUpload}>
            <Button type="normal" className="meinian-image-box-paginatio-new-create">
              新增图片
            </Button>
          </Upload>
        )}
        <BaseSortThumbs
          setInnerIndex={setInnerIndex}
          imgInfoList={imgInfoList}
          setImageId={setImageId}
          imageId={imageId}
          onDelete={onDelete}
          onSort={onSort}
          auth={isPermissions(currentImage.sampleClothingAuth, ['operateAndUpdateSample'])}
          hiddenDeleteBtn={hiddenDeleteBtn}
        />
      </div>
    </div>
  )
}

const BaseSortThumbs = ({ imgInfoList, setInnerIndex, setImageId, imageId, onDelete, onSort, auth, hiddenDeleteBtn }) => {
  const [drag, setDrag] = useState(false)
  const addDarg = () => {
    setDrag(true)
    document.onmouseup = () => {
      setDrag(false)
      document.onmouseup = null
    }
  }

  return (
    <SortList
      data={imgInfoList}
      onChange={(list, _oldId, oldIndex, newIndex) => {
        // setImageId(_oldId)
        setInnerIndex(oldIndex)
        if (oldIndex !== newIndex) {
          onSort(list)
        }
      }}
      disabled={!auth}
      itemRenderer={(img, index) => (
        <div
          className={classnames('thumbs-item', {
            'sortable-item': auth && drag,
          })}
          key={img.imageId}
          onMouseDown={() => {
            if (auth) {
              addDarg()
            }
            setImageId(img.imageId)
            setInnerIndex(index)
          }}
        >
          <div className={classnames('ins-detail-thumb', { active: img.imageId === imageId })}>
            {index === 0 ? (
              <FirstNormalTip title="长按可拖动图片排序" placement="right" keyValue="mn-detail-image-list">
                <img referrerPolicy="no-referrer" src={ossImg(img.mainUrl, 300, 300)} />
              </FirstNormalTip>
            ) : (
              <img referrerPolicy="no-referrer" src={ossImg(img.mainUrl, 300, 300)} />
            )}
            {img?.annotationNum > 0 ? (
              <div className="annotation-num">
                <span>批注</span>
                <span>{img?.annotationNum > 99 ? '99+' : img?.annotationNum}</span>
              </div>
            ) : null}
          </div>
          {imgInfoList.length > 1 && !hiddenDeleteBtn && auth && (
            <div
              className="ins-detail-thumb-delete-wrap"
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => onDelete(e, img)}
            >
              <Icon type="m-jianshao_tianchong" className="ins-detail-thumb-delete" />
            </div>
          )}
        </div>
      )}
    />
  )
}

const SortList = ({ data, itemRenderer, onChange, className, disabled = false, onSortStart }) => {
  const $container = useRef()
  useDeepCompareEffect(() => {
    if ($container.current.sortable) {
      $container.current.sortable.destroy()
    }
    $container.current.sortable = new Sortable($container.current, {
      draggable: '.sortable-item',
      mirror: {
        constrainDimensions: true,
      },
    })
    if ($container.current.sortable && disabled) {
      $container.current.sortable.destroy()
    }
    $container.current.sortable.on('sortable:start', ({ startIndex }) => {
      const newData = cloneDeep(data)
      const startId = newData.find((i, index) => index === startIndex).imageId
      onSortStart?.(startIndex, startId)
    })
    $container.current.sortable.on('sortable:stop', ({ data: { oldIndex, newIndex } }) => {
      if (oldIndex === newIndex) {
        onChange?.(data, data[newIndex].imageId, oldIndex, newIndex)
        return
      }
      const newData = cloneDeep(data)
      const temp = cloneDeep(newData[oldIndex])
      newData.splice(oldIndex, 1)
      newData.splice(newIndex, 0, temp)
      const _oldIndex = newData.findIndex((i, index) => index === oldIndex)
      onChange?.(newData, newData[_oldIndex].imageId, _oldIndex, newIndex)
    })
  }, [data, disabled])

  return (
    <div ref={$container} className={className}>
      {data.map((m, index) => itemRenderer(m, index))}
    </div>
  )
}
